//
// Copyright 2026 DXOS.org
//

// @import-as-namespace

import { ProgressPlugin } from '#plugin';

export { meta } from '#meta';

/** Constructs the plugin; the body is loaded eagerly. */
export const make = ProgressPlugin;
